var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-record-found"},[_c('div',{staticClass:"middle-align"},[_c('div',{staticClass:"no-record-image"},[_c('no-record-icon')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }